import FillMyForm from "./FillMyForm";
import FormDetails from "./FormDetails";

import Single3 from "./SBIAOF3/Single";
import Joint3 from "./SBIAOF3/Joint";

import Current1 from "./SBI_CA1/Current";
import Current2 from "./SBI_CA2/Current";
import Current_SP1 from "./SBI_CA_SP/Current";

import AEPS from "./SBI_AEPS/AEPS";
import MultiForm from "./SBI_MULTI_FORMS/MultiForm";
import HomeLoan from "./SBI_HOME_LOAN/HomeLoan";
import SBIKYC1 from "./SBIKYC1/SBIKYC1";
import SBIKYC3 from "./SBIKYC3/SBIKYC3";
import Inoperative from "./SBI_INOP/Inoperative";
import SBIPPF from "./SBIPPF/SBIPPF";
import SBICRF from "./SBICRF/SBICRF";
import Sukanya3 from "./SBISSA3/Sukanya3";
import SBIATM from "./SBIATM/SBIATM";
import SBIID from "./SBI_ID/SBIID";
import SBIMPF from "./SBIMPF/SBIMPF";

import SBI_AADHAAR_LINKING from "./SBI_AADHAAR_LINKING/SBI_AADHAAR_LINKING";
import SBI_FORM60 from "./SBI_FORM60/SBI_FORM60";
import NPCI_MAPPING from "./NPCI_MAPPING/NPCI_MAPPING";

import BOM_Single1 from "./BOM_AOF1/Single";
import BOM_Joint1 from "./BOM_AOF1/Joint";
import BOM_KYC from "./BOM_KYC/KYC";
import BOM_AADHAAR_LINKING from "./BOM_AADHAAR_LINKING/BOM_AADHAAR_LINKING";
import BOM_ATM from "./BOM_ATM/ATM";

import BOB_KYC from "./BOB_KYC1/KYC1";

import UIDMain from "./UID_FORMS/UIDMain";
import UIDNew from "./UID_FORMS/UIDNew";
import UIDUpdate from "./UID_FORMS/UIDUpdate";

import PANMain from "./PAN_FORMS/PANMain";
import PANNew from "./PAN_FORMS/PANNew";
import PANUpdate from "./PAN_FORMS/PANUpdate";

const fillMyFormRoutes = [
  {
    path: "/Fill_My_Form",
    element: <FillMyForm />,
  },

  /*
   * Common Form Details page
   */
  {
    path: "/form-details",
    element: <FormDetails />,
  },

  /*
   * SBI Account Opening Forms
   */
  {
    path: "/Fill_My_Form/SBIAOF3/Single",
    element: <Single3 />,
  },
  {
    path: "/Fill_My_Form/SBIAOF3/Joint",
    element: <Joint3 />,
  },

  /*
   * SBI Current Account Forms
   */
  {
    path: "/Fill_My_Form/SBI_CA1/Current",
    element: <Current1 />,
  },
  {
    path: "/Fill_My_Form/SBI_CA2/Current",
    element: <Current2 />,
  },
  {
    path: "/Fill_My_Form/SBI_CA_SP/Current",
    element: <Current_SP1 />,
  },

  /*
   * SBI Other Forms
   */
  {
    path: "/Fill_My_Form/SBI_AEPS/AEPS",
    element: <AEPS />,
  },
  {
    path: "/Fill_My_Form/SBI_MULTI_FORMS/MultiForm",
    element: <MultiForm />,
  },
  {
    path: "/Fill_My_Form/SBI_HOME_LOAN/HomeLoan",
    element: <HomeLoan />,
  },
  {
    path: "/Fill_My_Form/SBIKYC1/SBIKYC1",
    element: <SBIKYC1 />,
  },
  {
    path: "/Fill_My_Form/SBIKYC3/SBIKYC3",
    element: <SBIKYC3 />,
  },
  {
    path: "/Fill_My_Form/SBI_INOP/Inoperative",
    element: <Inoperative />,
  },
  {
    path: "/Fill_My_Form/SBIPPF/SBIPPF",
    element: <SBIPPF />,
  },
  {
    path: "/Fill_My_Form/SBICRF/SBICRF",
    element: <SBICRF />,
  },
  {
    path: "/Fill_My_Form/SBISSA3/Sukanya3",
    element: <Sukanya3 />,
  },
  {
    path: "/Fill_My_Form/SBIATM/SBIATM",
    element: <SBIATM />,
  },
  {
    path: "/Fill_My_Form/SBI_ID/SBIID",
    element: <SBIID />,
  },
  {
    path: "/Fill_My_Form/SBIMPF/SBIMPF",
    element: <SBIMPF />,
  },
  {
    path:
      "/Fill_My_Form/SBI_AADHAAR_LINKING/SBI_AADHAAR_LINKING",
    element: <SBI_AADHAAR_LINKING />,
  },
  {
    path: "/Fill_My_Form/SBI_FORM60/SBI_FORM60",
    element: <SBI_FORM60 />,
  },
  {
    path: "/Fill_My_Form/NPCI_MAPPING/NPCI_MAPPING",
    element: <NPCI_MAPPING />,
  },

  /*
   * Bank of Maharashtra Forms
   */
  {
    path: "/Fill_My_Form/BOM_AOF1/Single1",
    element: <BOM_Single1 />,
  },
  {
    path: "/Fill_My_Form/BOM_AOF1/Joint1",
    element: <BOM_Joint1 />,
  },
  {
    path: "/Fill_My_Form/BOM_KYC/KYC",
    element: <BOM_KYC />,
  },
  {
    path:
      "/Fill_My_Form/BOM_AADHAAR_LINKING/BOM_AADHAAR_LINKING",
    element: <BOM_AADHAAR_LINKING />,
  },
  {
    path: "/Fill_My_Form/BOM_ATM/ATM",
    element: <BOM_ATM />,
  },

  {
    path: "/Fill_My_Form/BOB_KYC1/KYC1",
    element: <BOB_KYC />,
   },

  /*
   * Aadhaar Forms
   */
  {
    path: "/Fill_My_Form/UID_FORMS/UIDMain",
    element: <UIDMain />,
  },
  {
    path: "/Fill_My_Form/UID_FORMS/UIDNew",
    element: <UIDNew />,
  },
  {
    path: "/Fill_My_Form/UID_FORMS/UIDUpdate",
    element: <UIDUpdate />,
  },

  /*
   * PAN Forms
   */
  {
    path: "/Fill_My_Form/PAN_FORMS/PANMain",
    element: <PANMain />,
  },
  {
    path: "/Fill_My_Form/PAN_FORMS/PANNew",
    element: <PANNew />,
  },
  {
    path: "/Fill_My_Form/PAN_FORMS/PANUpdate",
    element: <PANUpdate />,
  },
];

export default fillMyFormRoutes;